import { FieldProps } from "formik";
import React from "react";

import { ReactComponent as EyeCrossedIcon } from "nvent-web/assets/svg/eye-crossed.svg";
import { ReactComponent as EyeIcon } from "nvent-web/assets/svg/eye.svg";

import style from "./PasswordInput.module.scss";

interface State {
  isVisible: boolean;
}

interface PasswordInputProps extends FieldProps<any>, React.HTMLAttributes<HTMLInputElement> {}

export class PasswordInput extends React.Component<PasswordInputProps, State> {
  state = {
    isVisible: false,
  };

  render() {
    const { isVisible } = this.state;
    const { field, form: _, ...fieldProps } = this.props;
    const { name } = field;

    const type = isVisible ? "text" : "password";
    const ToggleIcon = isVisible ? EyeIcon : EyeCrossedIcon;

    return (
      <div className={style.inputContainer}>
        <input type={type} id={name} name={name} className={style.input} {...field} {...fieldProps} />
        <button type="button" onClick={this.toggleVisibility} className={style.toggleButton}>
          <ToggleIcon className={style.icon} />
        </button>
      </div>
    );
  }

  private toggleVisibility = () => {
    this.setState(({ isVisible }) => ({ isVisible: !isVisible }));
  };
}
